import React from 'react';
import { Navigate } from 'react-router-dom';

/** Profile lives on Account hub; keep route for old bookmarks. */
export const AccountProfilePage: React.FC = () => <Navigate to="/account" replace />;
